import React, { useState, useEffect } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import { getSupplierData } from "@/api/dashboard";

interface SupplierData {
  name: string;
  value: number;
  percentage: number;
  color: string;
}

const SupplierChart = () => {
  const [data, setData] = useState<SupplierData[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const supplierData = await getSupplierData();
        setData(supplierData || []);
      } catch (error) {
        console.error("Error fetching supplier data:", error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="bg-white p-6 rounded-lg shadow-sm">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold text-gray-800">
            Supplier Distribution
          </h2>
        </div>
        <div className="h-[300px] flex items-center justify-center">
          <div className="text-gray-500">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold text-gray-800">
          Supplier Distribution
        </h2>
        <button className="text-gray-400 hover:text-gray-600">•••</button>
      </div>

      <div className="h-[300px]">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={80}
              startAngle={90}
              endAngle={450}
              dataKey="value"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color || "#3B82F6"} />
              ))}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>

      <div className="space-y-4 mt-6">
        {data.map((item, index) => (
          <div key={index} className="flex items-center justify-between">
            <div className="flex items-center">
              <span
                className="w-3 h-3 rounded-full mr-2"
                style={{ backgroundColor: item.color || "#3B82F6" }}
              ></span>
              <span className="text-sm text-gray-800">
                {item.name || "Unknown"}
              </span>
            </div>
            <div className="flex items-center space-x-4">
              <span className="text-sm font-medium">
                {(item.value || 0).toLocaleString()}
              </span>
              <span className="text-sm text-green-500">
                +{item.percentage || 0}%
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SupplierChart;
